<template>
    <div class="panel">
        <div class="panel-body">
            <el-table
                    :data="locationTreeInfo"
                    style="width: 100%; margin-top:10px; margin-bottom: 25px; cursor: pointer"
                    border
                    highlight-current-row
                    :row-key="getRowKeys"
                    :expand-row-keys="expands"
                    :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                    @row-click="clickTableRow">
                <el-table-column prop="code" style="" label="位置信息" min-width="100%">
                    <template slot-scope="scope">
                        <span>{{`${scope.row.name}`}}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>

    import DcimServer from "@/api/dcim/index";

    export default {
        name: "locationTree",

        props: {
            roomId: {
                type: Number,
            },
        },

        data() {
            return {
                locationTreeInfo: [],

            }
        },

        methods: {
            clickTableRow(row, column, event) {
                this.$emit('selectedNode', row);
            },

            async queryTreeInfoOper(roomId) {
                await DcimServer.tree.findNodeAndDescendantsByPathCode(`/LOCATIONS:${roomId}`).then(res => {
                    if (res != null) {
                        this.locationTreeInfo = [res];
                    } else {
                        this.locationTreeInfo = [];
                    }
                });
            },

            // 获取row的key值（必须定义）
            getRowKeys(row) {
                return row.id;
            },

        },

        watch: {
            roomId: {
                immediate: true,
                handler: function (newVal, oldVal) {
                    this.queryTreeInfoOper(newVal);
                }
            },
        },

        computed: {
            expands() {
                let arr = new Array();
                if (this.locationTreeInfo != null && this.locationTreeInfo.length != 0) {
                    arr.push(this.locationTreeInfo[0].id + '')
                }
                return arr;
            },
        },

    }
</script>

<style scoped>

</style>